import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import API from "./Interceptor/ApiMiddleware";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const ProtectedRoute = ({ element }) => {
  const [authState, setAuthState] = useState({
    loading: true,
    authenticated: false,
  });

  useEffect(() => {
    const storedAuthState = localStorage.getItem("authState");

    if (storedAuthState) {
      setAuthState({ loading: false, authenticated: true });
    } else {
      API.get("/auth/verify-token", { withCredentials: true })
        .then((response) => {
          localStorage.setItem("authState", "authenticated");
          setAuthState({ loading: false, authenticated: true });
        })
        .catch((error) => {
          setAuthState({ loading: false, authenticated: false });
        });
    }
  }, []);

  if (authState.loading) {
    return (
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={authState.loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!authState.authenticated) {
    return <Navigate to="/login" replace />;
  }

  return element;
};

export default ProtectedRoute;
